const PLACEHOLDER = '/gfx/cart/noimage.svg';

/**
 * Configuration images are generated asynchronously by CP and the media row can
 * outlive the file, so a thumbnail URL is never a guarantee. Without this the
 * row shows the browser's broken image glyph.
 */
const usePlaceholder = (image) => {
    if (image.dataset.placeholder === '1') {
        return;
    }
    image.dataset.placeholder = '1';
    image.src = PLACEHOLDER;
    image.classList.add('is-placeholder');
};

document.addEventListener('DOMContentLoaded', () => {
    for (const image of document.querySelectorAll('.account-configuration-thumb')) {
        // the module is deferred, so an image may have failed before this runs
        if (image.complete && image.naturalWidth === 0) {
            usePlaceholder(image);
            continue;
        }

        image.addEventListener('error', () => usePlaceholder(image), {once: true});
    }
});
